import { render, staticRenderFns } from "./PayersBalance.vue?vue&type=template&id=0c9a2d16&scoped=true"
import script from "./PayersBalance.vue?vue&type=script&lang=js"
export * from "./PayersBalance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9a2d16",
  null
  
)

export default component.exports